import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, numberAttribute, booleanAttribute, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { DomHandler } from 'primeng/dom';
import * as i3 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';

/**
 * Steps components is an indicator for the steps in a wizard workflow.
 * @group Components
 */
const _c0 = ["list"];
const _c1 = a0 => ({
  "p-steps p-component": true,
  "p-readonly": a0
});
const _c2 = (a0, a1) => ({
  "p-highlight p-steps-current": a0,
  "p-disabled": a1
});
const _c3 = () => ({
  exact: false
});
function Steps_li_3_a_2_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.label);
  }
}
function Steps_li_3_a_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", item_r3.label, i0.ɵɵsanitizeHtml);
  }
}
function Steps_li_3_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵlistener("click", function Steps_li_3_a_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      const item_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onItemClick($event, item_r3, i_r4));
    })("keydown", function Steps_li_3_a_2_Template_a_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      const item_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onItemKeydown($event, item_r3, i_r4));
    });
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, Steps_li_3_a_2_span_3_Template, 2, 1, "span", 12)(4, Steps_li_3_a_2_ng_template_4_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const htmlLabel_r6 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", item_r3.routerLink)("queryParams", item_r3.queryParams)("routerLinkActive", "p-menuitem-link-active")("routerLinkActiveOptions", item_r3.routerLinkActiveOptions || i0.ɵɵpureFunction0(18, _c3))("target", item_r3.target)("fragment", item_r3.fragment)("queryParamsHandling", item_r3.queryParamsHandling)("preserveFragment", item_r3.preserveFragment)("skipLocationChange", item_r3.skipLocationChange)("replaceUrl", item_r3.replaceUrl)("state", item_r3.state);
    i0.ɵɵattribute("tabindex", -1)("aria-expanded", i_r4 === ctx_r4.activeIndex)("aria-disabled", item_r3.disabled || ctx_r4.readonly && i_r4 !== ctx_r4.activeIndex)("ariaCurrentWhenActive", ctx_r4.exact ? "step" : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r4 + 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.escape !== false)("ngIfElse", htmlLabel_r6);
  }
}
function Steps_li_3_ng_template_3_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r3.label);
  }
}
function Steps_li_3_ng_template_3_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", item_r3.label, i0.ɵɵsanitizeHtml);
  }
}
function Steps_li_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function Steps_li_3_ng_template_3_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      const item_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onItemClick($event, item_r3, i_r4));
    })("keydown", function Steps_li_3_ng_template_3_Template_a_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      const item_r3 = ctx_r1.$implicit;
      const i_r4 = ctx_r1.index;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.onItemKeydown($event, item_r3, i_r4));
    });
    i0.ɵɵelementStart(1, "span", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, Steps_li_3_ng_template_3_span_3_Template, 2, 1, "span", 12)(4, Steps_li_3_ng_template_3_ng_template_4_Template, 1, 1, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const htmlRouteLabel_r8 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    const item_r3 = ctx_r1.$implicit;
    const i_r4 = ctx_r1.index;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("target", item_r3.target);
    i0.ɵɵattribute("href", item_r3.url, i0.ɵɵsanitizeUrl)("tabindex", -1)("aria-expanded", i_r4 === ctx_r4.activeIndex)("aria-disabled", item_r3.disabled || ctx_r4.readonly && i_r4 !== ctx_r4.activeIndex)("ariaCurrentWhenActive", ctx_r4.exact && (!item_r3.disabled || ctx_r4.readonly) ? "step" : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i_r4 + 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.escape !== false)("ngIfElse", htmlRouteLabel_r8);
  }
}
function Steps_li_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 8, 1);
    i0.ɵɵtemplate(2, Steps_li_3_a_2_Template, 6, 19, "a", 9)(3, Steps_li_3_ng_template_3_Template, 6, 9, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const elseBlock_r9 = i0.ɵɵreference(4);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(item_r3.styleClass);
    i0.ɵɵproperty("ngStyle", item_r3.style)("tooltipOptions", item_r3.tooltipOptions)("ngClass", i0.ɵɵpureFunction2(13, _c2, ctx_r4.isActive(item_r3, i_r4), item_r3.disabled || ctx_r4.readonly && !ctx_r4.isActive(item_r3, i_r4)));
    i0.ɵɵattribute("aria-disabled", item_r3.disabled || ctx_r4.readonly && !ctx_r4.isActive(item_r3, i_r4) ? "true" : "false")("aria-current", ctx_r4.isActive(item_r3, i_r4) ? "step" : undefined)("id", item_r3.id)("tabindex", 0)("aria-label", item_r3.disabled || ctx_r4.readonly && !ctx_r4.isActive(item_r3, i_r4) ? ctx_r4.currentlyNotActive + (i_r4 + 1) + " " + item_r3.label : ctx_r4.currentlyActive + (i_r4 + 1) + " " + item_r3.label)("data-pc-section", "menuitem");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r4.isClickableRouterLink(item_r3))("ngIfElse", elseBlock_r9);
  }
}
let Steps = /*#__PURE__*/(() => {
  class Steps {
    router;
    route;
    cd;
    currentlyActive;
    currentlyNotActive;
    /**
     * Index of the active item.
     * @group Props
     */
    activeIndex = 0;
    /**
     * An array of menu items.
     * @group Props
     */
    model;
    /**
     * Whether the items are clickable or not.
     * @group Props
     */
    readonly = true;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    /**
     * Style class of the component.
     * @group Props
     */
    styleClass;
    /**
     * Whether to apply 'router-link-active-exact' class if route exactly matches the item path.
     * @group Props
     */
    exact = true;
    /**
     * Callback to invoke when the new step is selected.
     * @param {number} number - current index.
     * @group Emits
     */
    activeIndexChange = new EventEmitter();
    listViewChild;
    constructor(router, route, cd) {
      this.router = router;
      this.route = route;
      this.cd = cd;
    }
    subscription;
    ngOnInit() {
      this.subscription = this.router.events.subscribe(() => this.cd.markForCheck());
    }
    onItemClick(event, item, i) {
      if (this.readonly || item.disabled) {
        event.preventDefault();
        return;
      }
      this.activeIndexChange.emit(i);
      if (!item.url && !item.routerLink) {
        event.preventDefault();
      }
      if (item.command) {
        item.command({
          originalEvent: event,
          item: item,
          index: i
        });
      }
    }
    onItemKeydown(event, item, i) {
      switch (event.code) {
        case 'ArrowRight':
          {
            this.navigateToNextItem(event.target);
            event.preventDefault();
            break;
          }
        case 'ArrowLeft':
          {
            this.navigateToPrevItem(event.target);
            event.preventDefault();
            break;
          }
        case 'Home':
          {
            this.navigateToFirstItem(event.target);
            event.preventDefault();
            break;
          }
        case 'End':
          {
            this.navigateToLastItem(event.target);
            event.preventDefault();
            break;
          }
        case 'Tab':
          if (i !== this.activeIndex) {
            const siblings = DomHandler.find(this.listViewChild.nativeElement, '[data-pc-section="menuitem"]');
            siblings[i].children[0].tabIndex = '-1';
            siblings[this.activeIndex].children[0].tabIndex = '0';
          }
          break;
        case 'Enter':
        case 'Space':
          {
            this.onItemClick(event, item, i);
            event.preventDefault();
            break;
          }
        default:
          break;
      }
    }
    navigateToNextItem(target) {
      const nextItem = this.findNextItem(target);
      nextItem && this.setFocusToMenuitem(target, nextItem);
    }
    navigateToPrevItem(target) {
      const prevItem = this.findPrevItem(target);
      prevItem && this.setFocusToMenuitem(target, prevItem);
    }
    navigateToFirstItem(target) {
      const firstItem = this.findFirstItem();
      firstItem && this.setFocusToMenuitem(target, firstItem);
    }
    navigateToLastItem(target) {
      const lastItem = this.findLastItem();
      lastItem && this.setFocusToMenuitem(target, lastItem);
    }
    findNextItem(item) {
      const nextItem = item.parentElement.nextElementSibling;
      return nextItem ? nextItem.children[0] : null;
    }
    findPrevItem(item) {
      const prevItem = item.parentElement.previousElementSibling;
      return prevItem ? prevItem.children[0] : null;
    }
    findFirstItem() {
      const firstSibling = DomHandler.findSingle(this.listViewChild.nativeElement, '[data-pc-section="menuitem"]');
      return firstSibling ? firstSibling.children[0] : null;
    }
    findLastItem() {
      const siblings = DomHandler.find(this.listViewChild.nativeElement, '[data-pc-section="menuitem"]');
      return siblings ? siblings[siblings.length - 1].children[0] : null;
    }
    setFocusToMenuitem(target, focusableItem) {
      target.tabIndex = '-1';
      focusableItem.tabIndex = '0';
      focusableItem.focus();
    }
    isClickableRouterLink(item) {
      return item.routerLink && !this.readonly && !item.disabled;
    }
    isActive(item, index) {
      if (item.routerLink) {
        let routerLink = Array.isArray(item.routerLink) ? item.routerLink : [item.routerLink];
        return this.router.isActive(this.router.createUrlTree(routerLink, {
          relativeTo: this.route
        }).toString(), false);
      }
      return index === this.activeIndex;
    }
    getItemTabIndex(item, index) {
      if (item.disabled) {
        return '-1';
      }
      if (!item.disabled && this.activeIndex === index) {
        return item.tabindex || '0';
      }
      return item.tabindex ?? '-1';
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    static ɵfac = function Steps_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || Steps)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Steps,
      selectors: [["p-steps"]],
      viewQuery: function Steps_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listViewChild = _t.first);
        }
      },
      hostAttrs: [1, "p-element"],
      inputs: {
        currentlyActive: "currentlyActive",
        currentlyNotActive: "currentlyNotActive",
        activeIndex: [2, "activeIndex", "activeIndex", numberAttribute],
        model: "model",
        readonly: [2, "readonly", "readonly", booleanAttribute],
        style: "style",
        styleClass: "styleClass",
        exact: [2, "exact", "exact", booleanAttribute]
      },
      outputs: {
        activeIndexChange: "activeIndexChange"
      },
      standalone: false,
      features: [i0.ɵɵInputTransformsFeature],
      decls: 4,
      vars: 9,
      consts: [["list", ""], ["menuitem", ""], ["elseBlock", ""], ["htmlLabel", ""], ["htmlRouteLabel", ""], [3, "ngClass", "ngStyle"], ["role", "tablist"], ["class", "p-steps-item", "role", "tab", "pTooltip", "", 3, "ngStyle", "class", "tooltipOptions", "ngClass", 4, "ngFor", "ngForOf"], ["role", "tab", "pTooltip", "", 1, "p-steps-item", 3, "ngStyle", "tooltipOptions", "ngClass"], ["role", "presentation", "class", "p-menuitem-link", 3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click", "keydown", 4, "ngIf", "ngIfElse"], ["role", "presentation", 1, "p-menuitem-link", 3, "click", "keydown", "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "target", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state"], [1, "p-steps-number"], ["class", "p-steps-title", 4, "ngIf", "ngIfElse"], [1, "p-steps-title"], [1, "p-steps-title", 3, "innerHTML"], ["role", "presentation", 1, "p-menuitem-link", 3, "click", "keydown", "target"]],
      template: function Steps_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 5)(1, "ul", 6, 0);
          i0.ɵɵtemplate(3, Steps_li_3_Template, 5, 16, "li", 7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClass);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx.readonly))("ngStyle", ctx.style);
          i0.ɵɵattribute("data-pc-name", "steps");
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-pc-section", "menu");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.model);
        }
      },
      dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgStyle, i1.RouterLink, i1.RouterLinkActive, i3.Tooltip],
      styles: [".p-steps{position:relative}.p-steps ul{padding:0;margin:0;list-style-type:none;display:flex}.p-steps-item{position:relative;display:flex;justify-content:center;flex:1 1 auto}.p-steps-item .p-menuitem-link{display:inline-flex;flex-direction:column;align-items:center;overflow:hidden;text-decoration:none}.p-steps.p-steps-readonly .p-steps-item{cursor:auto}.p-steps-item.p-steps-current .p-menuitem-link{cursor:default}.p-steps-title{white-space:nowrap}.p-steps-number{display:flex;align-items:center;justify-content:center}.p-steps-title{display:block}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Steps;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StepsModule = /*#__PURE__*/(() => {
  class StepsModule {
    static ɵfac = function StepsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StepsModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StepsModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, TooltipModule, RouterModule, TooltipModule]
    });
  }
  return StepsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Steps, StepsModule };
